import React, { useEffect, useRef,useState, setState } from "react"
import { Map, View } from "ol"
import { transform} from 'ol/proj.js';

import Zoom from 'ol/control/Zoom.js';
import ScaleLine from 'ol/control/ScaleLine.js';
import LayerGroup  from "ol/layer/Group.js";
import GeoJSON from 'ol/format/GeoJSON.js';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import Select from 'ol/interaction/Select.js';
import Style from 'ol/style/Style.js';

import MapContext from "./MapContext";
import {SideBar} from "../Scripts/SideBar";
import {SideBarEnd} from "../Scripts/SideBarEnd";
import {Search} from "../Scripts/Search";
import {PlanDeCoupe} from "../Scripts/PlanDeCoupe";
import {PopupMatiere} from "../Scripts/PopupMatiere";
import {PopupBatiment} from "../Scripts/PopupBatiment";
import {SideBarEndMatiere} from "../Scripts/SideBarEndMatiere";
import {SelectBackground} from "./outils/SelectBackground";
import {printControlBar} from "./outils/Print";
import {mousePositionTool} from "./outils/MousePosition";

import {findMatiereById,findMatiereByName} from "./services/Matiere";
import BatimentService from "./services/Batiment";

import $ from "jquery";

import {
    globalMapExtent,
    globalProjection,
    globalMatrixIds,
    globalResolutions,
    globalMaxResolution,
    globalTileGrid,
    projection2154,
    projection3857,
    urlDirectus, startMapExtent
} from "./config/globals.js";

//importer les fonds
import {
    ignLayer,
    mntColorimetrieWmtsLayer,
    mntNbWmtsLayer, planIgnLayer
} from "./config/layersBackground.js";

//importer layers BioRegions
import {
    brForetWmsLayer,
    brGeologieWmsLayer,
    brReliefWmsLayer,
    brTempWmsLayer,
    bvWmsLayer,
    communesWmsLayer} from "./config/layersBioregions";

//layers geologie
import {
    geologieFiltreWmsLayer,
    carriereWmsLayer,
    geologieProperties,
    paramCarriereRepresentation, paramGeologieRepresentation
} from "./config/layersGeologie";

//layers Bio
import {
    foretWmsLayer,
    cultureWmsLayer,
    paramForetRepresentation,
    paramCultureRepresentation
} from "./config/layersBiosources";

//layers Climat
import {
    climatWmsLayer,
    paramClimatRepresentation,
    paramClimatAnnee
} from "./config/layersClimat";

import {paramLegendTitles} from "./config/legend";

import {getArea, getLength} from 'ol/sphere.js';

//Layer Batiment
import {markerStyle,batimentVectorSource,batimentVectorLayer, createStyle} from "./config/layersBatiment";

import {PopupEdito} from "../Scripts/PopupEdito";
import {PopupImage} from "../Scripts/PopupImage";




const formatArea = function (polygon) {
    const area = getArea(polygon);
    let output;
    if (area > 10000) {
        output = Math.round((area / 1000000) * 100) / 100 + ' km\xB2';
    } else {
        output = Math.round(area * 100) / 100 + ' m\xB2';
    }
    return output;
};

function MapComponent() {


    function setGeologieFilterAndRefresh() {

        var materiauFilterList=[];
        geoProps.forEach(function (materiau, i) {
            if(materiau.active){
                materiauFilterList.push(materiau.id);
            }
        });

        geologieFiltreWmsLayer.getSource().updateParams({
            'VIEWPARAMS': 'filtre_valorisations:' + materiauFilterList
        });

        geologieFiltreWmsLayer.getSource().refresh();
    }
    function showLayer(titleLayer){
        layers.getLayers().getArray().find(l => l.get('title') === titleLayer).setVisible(true);
    }
    function showBaseLayer(titleLayer){
        //Masquer tous les layers de base
        const ls = backgroundLayers.getLayers().getArray().slice().reverse();
        ls.forEach(function (layer, i) {
            layer.setVisible(false);
        });
        backgroundLayers.getLayers().getArray().find(l => l.get('title') === titleLayer).setVisible(true);
        setBackgroundActif(titleLayer);
    }

    function hideOtherDataLayer(idCheck){
        if(idCheck == "bassinsversants"){
            if(bvWmsLayerVisible == true) {
                layers.getLayers().getArray().find(l => l.get('title') === "Bassins versants").setVisible(false);
                setBvWmsLayerVisible(false);
            }else{
                layers.getLayers().getArray().find(l => l.get('title') === "Bassins versants").setVisible(true);
                setBvWmsLayerVisible(true);
            }
        }
        if(idCheck == "villesetvillages"){
            if(communesWmsLayerVisible == true){
                layers.getLayers().getArray().find(l => l.get('title') === "Villes et villages").setVisible(false);
                setCommunesWmsLayerVisible(false);
            }else {
                layers.getLayers().getArray().find(l => l.get('title') === "Villes et villages").setVisible(true);
                setCommunesWmsLayerVisible(true);
            }

        }

        if(idCheck == "brforet"){
            if(brForetWmsLayerVisible == true) {
                layers.getLayers().getArray().find(l => l.get('title') === "Biorégions forêts").setVisible(false);
                setBrForetWmsLayerVisible(false);
            }else{
                layers.getLayers().getArray().find(l => l.get('title') === "Biorégions forêts").setVisible(true);
                setBrForetWmsLayerVisible(true);
            }
        }
        if(idCheck == "brgeo"){
            if(brGeologieWmsLayerVisible == true) {
                layers.getLayers().getArray().find(l => l.get('title') === "Biorégions géologie").setVisible(false);
                setBrGeologieWmsLayerVisible(false);
            }else{
                layers.getLayers().getArray().find(l => l.get('title') === "Biorégions géologie").setVisible(true);
                setBrGeologieWmsLayerVisible(true);
            }
        }
        if(idCheck == "brrelief"){
            if(brReliefWmsLayerVisible == true) {
                layers.getLayers().getArray().find(l => l.get('title') === "Biorégions relief").setVisible(false);
                setBrReliefWmsLayerVisible(false);
            }else{
                layers.getLayers().getArray().find(l => l.get('title') === "Biorégions relief").setVisible(true);
                setBrReliefWmsLayerVisible(true);
            }
        }
        if(idCheck == "brtemp"){
            if(brTempWmsLayerVisible == true){
                layers.getLayers().getArray().find(l => l.get('title') === "Biorégions Températures").setVisible(false);
                setBrTempWmsLayerVisible(false);
            }else {
                layers.getLayers().getArray().find(l => l.get('title') === "Biorégions Températures").setVisible(true);
                setBrTempWmsLayerVisible(true);
            }

        }

        showLegend();
    }

    function showLayerGeologie(){
        if(geologieLayerVisible == true) {
            layers.getLayers().getArray().find(l => l.get('title') === "Géologie").setVisible(false);
            setGeologieLayerVisible(false);
        }else{
            layers.getLayers().getArray().find(l => l.get('title') === "Géologie").setVisible(true);
            setGeologieLayerVisible(true);
        }
        showLegend();
    }

    function showLegend() {
        let html='';

        legendsLayers.getLayers().forEach((layer) => {
            if(layer.getVisible() === true){


                //&legend_options=hideEmptyRules
                const layerSource = layer.getSource();
                let valLayer = layerSource.getParams().LAYERS;
                let sub;
                valLayer=valLayer.replaceAll('ref_geo:','');

                //cas de la litogolgie en image png
                if(valLayer.indexOf('geologie_agg_lito') != -1 || valLayer.indexOf('geologie_agg_matiere') != -1 ){
                    let src;
                    let zoomActuel = map.getView().getZoom();
                    if(valLayer.indexOf('geologie_agg_lito') != -1){
                        sub = 'Lithologie';
                        if(zoomActuel < 11 ){
                            src ='/legend/legende_geologie_lito_echelle_1_fond.png';
                        }else if(zoomActuel >= 11 && zoomActuel < 12){
                            src ='/legend/legende_geologie_lito_echelle_2_fond.png';
                        }else{
                            src ='/legend/legende_geologie_lito_echelle_3_fond.png';
                        }

                    }

                    if(valLayer.indexOf('geologie_agg_matiere') != -1){
                        sub = 'Matière';
                        if(zoomActuel < 11 ){
                            src ='/legend/legende_geologie_mat_echelle_1_fond.png';
                        }else{
                            src ='/legend/legende_geologie_mat_echelle_2_fond.png';
                        }
                    }

                    let img = '<div class="choix-fond-titre d-flex pb-3"><div class="col-4"><div class="dotted-pattern w-100"></div></div>';
                    img += '<span class="fs-7 ms-1 d-flex flex-column justify-content-end lh-xs pb-1 ps-2"><strong>'+layer.get('title')+'</strong><span>' + sub + '</span></span>';
                    img += '</div>';
                    img += '<img src="'+src+'">';

                    html+= img;
                }else {


                    let legendUrl = 'https://ensam-gs.agaricids.com/geoserver/ref_geo/wms?request=getlegendgraphic&service=wms&layer=' + valLayer + '&format=image/png&LEGEND_OPTIONS=forceTitles:off&style=';


                    if (valLayer.indexOf('dc_agg') != -1) {
                        //récupérer année et représentation

                        sub = $('#anneeClimat').find(':selected').text();
                        sub += ' - ' + $('#represClimat').find(':selected').text();
                    } else {

                        let style = layerSource.getParams().STYLES;
                        if (style != undefined) legendUrl += style;

                        let subTitle = objectLegend.find((element) => {
                            return element.id === style;
                        });

                        if (subTitle) {
                            sub = subTitle.nom;
                        } else {
                            sub = "";
                        }
                    }

                    let img = '<div class="choix-fond-titre d-flex pb-3"><div class="col-4"><div class="dotted-pattern w-100"></div></div>';
                    img += '<span class="fs-7 ms-1 d-flex flex-column justify-content-end lh-xs pb-1 ps-2"><strong>' + layer.get('title') + '</strong><span>' + sub + '</span></span>';
                    img += '</div>';
                    img += '<img src="' + legendUrl + '">';

                    html += img;
                }
            }
        });
        $('#legend').html(html);
    }

    function closeAllPopup(){
        closePopupMatiere();
        closeDetailMatiere();
        closePopupBatiment();
        closeDetailBatiment();
        closePlanDeCoupe();
    }
    function showPopupBatiment(){
        closeAllPopup();
        $('#infos-batiment').addClass('visible');
    }
    function closePopupBatiment(){
        $('#infos-batiment').removeClass('visible');
    }

    function showPopupEdito(){
        closeAllPopup();
        $('#infos-edito').addClass('visible');
    }
    function closePopupEdito(){
        $('#infos-edito').removeClass('visible');
    }


    function showPopupImage(){
        $('#popup-image').removeClass('off');
    }
    function closePopupImage(){
        $('#popup-image').addClass('off');
    }

    function setAndShowImage(type,src,titre,source){

        var image = {
            "src" : src,
            "titre" : titre,
            "source" : source
        };
        if(type=='scroll'){
            setImageCourante({});
            setImageScroll(image);
        }else {
            setImageCourante(image);
            setImageScroll({});
        }
        showPopupImage();

    }

    function showDetailBatiment(){
        closePopupBatiment();
        $('#side-bar-batiment').removeClass('off');

    }
    function closeDetailBatiment(){
        $('#side-bar-batiment').addClass('off');
    }

    function showPlanDeCoupe(type){
        setAffichePlanDeCoupeMaquette(type);
        $('#plan-coupe-interactif').removeClass('off');

    }
    function closePlanDeCoupe(){
        $('#plan-coupe-interactif').addClass('off');
    }

    function showMatiere(){
        //closeAllPopup();
        closePopupMatiere();
        closeDetailMatiere();
        closePopupBatiment();
        //closeDetailBatiment();
        //closePlanDeCoupe();
        $('#side-bar-matiere').removeClass('off');
    }
    function closeDetailMatiere(){
        $('#side-bar-matiere').addClass('off');
    }


    function showPopupMatiere(classn,titre,stitre,matiere,superficie){
        closeAllPopup();
        //remove des class

        $('#infos-matiere').removeClass('foret');
        $('#infos-matiere').removeClass('culture');
        $('#infos-matiere').removeClass('geo');

        $('#titre-matiere').html(titre);
        $('#stitre-matiere').html(stitre);
        $('#detail-matiere').html(matiere);
        $('#superficie-matiere').html(superficie);

        $('#infos-matiere').addClass(classn);
        $('#infos-matiere').addClass('visible');
    }
    function closePopupMatiere(){
        $('#infos-matiere').removeClass('visible');

    }

    const handleFindMatiereByName = async (classN,mat) => {
        try{
            const data = await findMatiereByName(classN,mat);
            setListeMatiereCourante(data);
        }catch (error){
            console.log(error);
        }
    }

    function setMatiereCouranteandShow(matiere){
        setMatiereCourante(matiere);
        showMatiere();

    }

    function getInfoMat (){
        let viewResolution = /** @type {number} */ (map.getView().getResolution());


        let coordinate = $('#coordinatesClick').val();
        let explodeCoord=coordinate.split(',');
        let x = parseFloat(explodeCoord[0]);
        let y = parseFloat(explodeCoord[1])
        var coords = transform([x,y], projection3857, projection2154);
        //var coords = [x,y];


        matieresLayers.getLayers().forEach((layer) => {


            if (layer.getVisible() === true) {
                if (
                    (layer.get('title') == 'Géologie')
                    || (layer.get('title') == 'Forêts')
                    || (layer.get('title') == 'Cultures')
                ){
                    const url = layer.getSource().getFeatureInfoUrl(
                        coords,
                        viewResolution,
                        'EPSG:2154',
                        {
                            'INFO_FORMAT': 'application/json'
                            //,'QUERY_LAYERS':
                        },
                    );
                    if (url) {
                        fetch(url)
                            .then((response) => response.text())
                            .then((html) => {
                                let feat = new GeoJSON().readFeatures(html);
                                if (feat.length > 0) {
                                    let classN;
                                    let area = formatArea(feat[0].getGeometry());
                                    let title;
                                    let subtitle;
                                    let mat;
//console.log(feat[0]);

                                    if (feat[0].values_.essence) {
                                        //foret
                                        classN = 'foret';
                                        title = 'Forêts';
                                        subtitle = feat[0].values_.tfv;
                                        mat = feat[0].values_.essence;

                                        handleFindMatiereByName(classN,mat);


                                    }

                                    if (feat[0].values_.code_cultu) {
                                        //culture
                                        classN = 'culture';
                                        title = 'Cultures';
                                        subtitle = feat[0].values_.descreduit + ' - ' + feat[0].values_.module_matiere;
                                        mat = feat[0].values_.descreduit;

                                        handleFindMatiereByName(classN,mat);
                                    }

                                    if (feat[0].values_.des_text_age) {
                                        //geo
                                        classN = 'geo';
                                        title = 'Géologie Matière';
                                        subtitle = feat[0].values_.descreduit + ' - ' + feat[0].values_.descr;
                                        mat = feat[0].values_.des_text_age;

                                        handleFindMatiereByName(classN,mat);
                                    }

                                    showPopupMatiere(classN, title, subtitle, mat, area);
                                } else {
                                    closePopupBatiment();
                                }


                            });
                    }
                }
            }
        });
    }
    function showLayerCarrieres(){
        if(carrieresLayerVisible == true) {
            layers.getLayers().getArray().find(l => l.get('title') === "Carrières").setVisible(false);
            setCarrieresLayerVisible(false);
        }else{
            layers.getLayers().getArray().find(l => l.get('title') === "Carrières").setVisible(true);
            setCarrieresLayerVisible(true);
        }
        showLegend();
    }

    function setStyleCarrieresLayer(style) {
        carriereWmsLayer.getSource().updateParams({
            'STYLES': style
        });
        carriereWmsLayer.getSource().refresh();
        showLegend();
    }

    function setStyleGeologieLayer(layer) {
        //décomposer pour former le nom du style
        let style='geologie_lito_presence_argile';
        if(layer == 'geologie_agg_matiere') style='geologie_mat_presence_argile';

        geologieFiltreWmsLayer.getSource().updateParams({
            'LAYERS' : 'ref_geo:'+layer,
            'STYLE': style
        });
        geologieFiltreWmsLayer.getSource().refresh();
        showLegend();
    }

    function showLayerForet(){
        if(foretLayerVisible == true) {
            layers.getLayers().getArray().find(l => l.get('title') === "Forêts").setVisible(false);
            setForetLayerVisible(false);
        }else{
            layers.getLayers().getArray().find(l => l.get('title') === "Forêts").setVisible(true);
            setForetLayerVisible(true);
        }
        showLegend();
    }

    function setStyleForetLayer(style) {
        foretWmsLayer.getSource().updateParams({
            'STYLES': style
        });
        foretWmsLayer.getSource().refresh();
        showLegend();
    }

    function showLayerCulture(){
        if(cultureLayerVisible == true) {
            layers.getLayers().getArray().find(l => l.get('title') === "Cultures").setVisible(false);
            setCultureLayerVisible(false);
        }else{
            layers.getLayers().getArray().find(l => l.get('title') === "Cultures").setVisible(true);
            setCultureLayerVisible(true);
        }
        showLegend();
    }

    function setStyleCultureLayer(style) {
        cultureWmsLayer.getSource().updateParams({
            'STYLES': style
        });
        cultureWmsLayer.getSource().refresh();
        showLegend();
    }

    function showLayerClimat(){
        if(climatLayerVisible == true) {
            layers.getLayers().getArray().find(l => l.get('title') === "Climat").setVisible(false);
            setClimatLayerVisible(false);
        }else{
            layers.getLayers().getArray().find(l => l.get('title') === "Climat").setVisible(true);
            setClimatLayerVisible(true);
        }
        showLegend();
    }

    function setStyleClimatLayer() {
        //récupérer l'année

        //represClimat
        let annee=$('#anneeClimat').val();
        let style=$('#represClimat').val();
        climatWmsLayer.getSource().updateParams({
            'LAYERS': annee+style
        });
        climatWmsLayer.getSource().refresh();
        showLegend();
    }


    function selectCommune(object) {

        const polygon = new GeoJSON().readGeometry(object.geom,projection2154);
        map.getView().fit(polygon.transform(projection2154,projection3857).getExtent(),map.getSize());
        setListHide(true);

    }

    function createMarker(latLon,bat){
        var coords = new transform(latLon,'EPSG:4326','EPSG:3857');
        let photot = null;
        if(bat.photo) photot=bat.photo.id

        const iconFeature =  new Feature({
            geometry: new Point(coords),
            type : "batiment",
            id:bat.id,
            nom: bat.nom,
            photo:photot,
            ref:bat.ref,
            adresse:bat.adresse,
            ville:bat.ville,
            infos:bat
        });

        iconFeature.set('style', createStyle('/legend/picto-map-batiment.png', undefined));
        return iconFeature;
    }
    function showLayerBatiment(){

        if(batimentLayerVisible == true) {
            layers.getLayers().getArray().find(l => l.get('title') === "Bâtiments").setVisible(false);
            setBatimentVisible(false);
        }else{
            layers.getLayers().getArray().find(l => l.get('title') === "Bâtiments").setVisible(true);
            setBatimentVisible(true);

            batimentVectorLayer.getSource().clear();

            batiments.map((bat,i)=> {
                batimentVectorLayer.getSource().addFeature(createMarker(bat.localisation.coordinates,bat));
            });


           // batimentVectorLayer.getSource().addFeature(createMarker([5.925727552777074,43.13123111355178],'Toulon'));
        }
    }

    function hideLayersForMatiere(){
        hideAllOtherDataLayer();
        hideLayerGeo();
        hideLayerBio();
        hideLayerClimat();
        //hideLayerBati();
    }
    function hideAllLayers(){
        hideAllOtherDataLayer();
        hideLayerGeo();
        hideLayerBio();
        hideLayerClimat();
        hideLayerBati();
    }

    function hideAllOtherDataLayer(){
        //bassinsversants
        layers.getLayers().getArray().find(l => l.get('title') === "Bassins versants").setVisible(false);
        setBvWmsLayerVisible(false);

        //villesetvillages
        layers.getLayers().getArray().find(l => l.get('title') === "Villes et villages").setVisible(false);
        setCommunesWmsLayerVisible(false);

        //brforet
        layers.getLayers().getArray().find(l => l.get('title') === "Biorégions forêts").setVisible(false);
        setBrForetWmsLayerVisible(false);

        //brgeo
        layers.getLayers().getArray().find(l => l.get('title') === "Biorégions géologie").setVisible(false);
        setBrGeologieWmsLayerVisible(false);

        //brrelief
        layers.getLayers().getArray().find(l => l.get('title') === "Biorégions relief").setVisible(false);
        setBrReliefWmsLayerVisible(false);

        //brtemp
        layers.getLayers().getArray().find(l => l.get('title') === "Biorégions Températures").setVisible(false);
        setBrTempWmsLayerVisible(false);

    }

    function hideLayerGeo(){
        //Carrières
        layers.getLayers().getArray().find(l => l.get('title') === "Carrières").setVisible(false);
        setCarrieresLayerVisible(false);

        //Géologie
        layers.getLayers().getArray().find(l => l.get('title') === "Géologie").setVisible(false);
        setGeologieLayerVisible(false);
    }

    function hideLayerBio(){
        //Cultures
        layers.getLayers().getArray().find(l => l.get('title') === "Cultures").setVisible(false);
        setCultureLayerVisible(false);

        //Forêts
        layers.getLayers().getArray().find(l => l.get('title') === "Forêts").setVisible(false);
        setForetLayerVisible(false);
    }

    function hideLayerClimat(){
        layers.getLayers().getArray().find(l => l.get('title') === "Climat").setVisible(false);
        setClimatLayerVisible(false);
    }
    function hideLayerBati(){
        //Bâtiments
        layers.getLayers().getArray().find(l => l.get('title') === "Bâtiments").setVisible(false);
        setBatimentVisible(false);
    }

    function resetAndShowOneLayer(layer){
        //hide allLayers sauf bâtiments
        hideLayersForMatiere();
        //desactiver les thematiques
        $('.acces-thematique').removeClass('on');
        $('.ss-menu-thematique').removeClass('visible');
        //activer batiments
        $('.thematique-5').addClass('on');

        //masquer le plan de coupe
        closePlanDeCoupe();

        if(layer=='Forêts' || layer == 'foret'){
            layers.getLayers().getArray().find(l => l.get('title') === "Forêts").setVisible(true);
            setForetLayerVisible(true);

            //charger la bonne représentation
            setSelectForetValue('forets_bois_oeuvre');
            setStyleForetLayer('forets_bois_oeuvre');

            //activer le bouton
            $('.acces-thematique.thematique-3').addClass('on');
            $('.ss-menu-thematique.thematique-3').addClass('visible');
        }
        if(layer=='Géologie' || layer == 'geo'){
            layers.getLayers().getArray().find(l => l.get('title') === "Géologie").setVisible(true);
            setGeologieLayerVisible(true);

            //charger la bonne représentation
            setSelectGeoValue('geologie_agg_matiere');
            setStyleGeologieLayer('geologie_agg_matiere');

            //activer le bouton
            $('.acces-thematique.thematique-2').addClass('on');
            $('.ss-menu-thematique.thematique-2').addClass('visible');
        }
        if(layer=='Cultures' || layer == 'culture'){
            layers.getLayers().getArray().find(l => l.get('title') === "Cultures").setVisible(true);
            setCultureLayerVisible(true);

            //changer la valeur du select
            setSelectCultureValue('cultures_matiere');
            setStyleCultureLayer('cultures_matiere');

            //activer le bouton
            $('.acces-thematique.thematique-3').addClass('on');
            $('.ss-menu-thematique.thematique-3').addClass('visible');
        }

        showLegend();
    }
    /*
        const search = window.location.search;
        const params = new URLSearchParams(search);

        useEffect(() => {
            setTimeout(() => {
                preselectLayer(params);
            },2000)
        }, [])
    */


    const mapRef = useRef();
    const [map, setMap] = useState(null);

    const [backgroundLayers, setBackgroundLayers] = useState(null);
    const [legendsLayers,setLegendsLayers]= useState(null);
    const [layers, setLayers] = useState(null);
    const [matieresLayers, setMatieresLayers] = useState(null);


    const [backgroundActif, setBackgroundActif] = useState('Relief ombré N&B');

    const [geoProps, setGeoProps] = useState(geologieProperties);

    const [bvWmsLayerVisible, setBvWmsLayerVisible] = useState(false);
    const [communesWmsLayerVisible, setCommunesWmsLayerVisible] = useState(false);
    const [brForetWmsLayerVisible, setBrForetWmsLayerVisible] = useState(false);
    const [brGeologieWmsLayerVisible, setBrGeologieWmsLayerVisible] = useState(false);
    const [brReliefWmsLayerVisible, setBrReliefWmsLayerVisible] = useState(false);
    const [brTempWmsLayerVisible, setBrTempWmsLayerVisible] = useState(false);

    const [geologieLayerVisible, setGeologieLayerVisible] = useState(false);
    const [carrieresLayerVisible, setCarrieresLayerVisible] = useState(false);

    const [foretLayerVisible, setForetLayerVisible] = useState(false);
    const [cultureLayerVisible, setCultureLayerVisible] = useState(false);
    const [climatLayerVisible, setClimatLayerVisible] = useState(false);


    const [foretRepresentation, setForetRepresentation] = useState(paramForetRepresentation);
    const [cultureRepresentation, setCultureRepresentation] = useState(paramCultureRepresentation);
    const [geologieRepresentation, setGeologieRepresentation] = useState(paramGeologieRepresentation);
    const [carriereRepresentation, setCarriereRepresentation] = useState(paramCarriereRepresentation);
    const [climatRepresentation, setClimatRepresentation] = useState(paramClimatRepresentation);
    const [climatAnnee, setClimatAnnee] = useState(paramClimatAnnee);

    const [objectLegend, setObjectLegend] = useState(paramLegendTitles);

    const[listHide,setListHide] = useState(false);

    const[batiments, setBatiments] = useState([]);
    const [batimentLayerVisible, setBatimentVisible] = useState(false);
    const[batimentCourant, setBatimentCourant] = useState([]);
    const[listeMatiereCourante, setListeMatiereCourante] = useState([]);
    const[matiereCourante, setMatiereCourante] = useState([]);

    const [selectGeoValue, setSelectGeoValue] = useState('geologie_agg_lito');
    const [selectCarriereValue, setSelectCarriereValue] = useState('carrieres_statut');
    const [selectForetValue, setSelectForetValue] = useState('forets_type_peuplement');
    const [selectCultureValue, setSelectCultureValue] = useState('cultures_description');
    const [selectClimatAnneeValue, setSelectClimatAnneeValue] = useState('dc_agg_2020');
    const [selectClimatValue, setSelectClimatValue] = useState('_pluviom');

    const[imageCourante, setImageCourante] = useState([]);
    const[imageScroll, setImageScroll] = useState([]);
    const[affichePlanDeCoupeMaquette, setAffichePlanDeCoupeMaquette] = useState(0);


    const fetchBatiements = async() => {
        try{
            const data = await BatimentService.findAll();
            setBatiments(data);
            console.log(data);
        }catch (error){
            console.log(error);
        }
    }
    useEffect(() => {
        fetchBatiements();
    }, [])

    var backLayers = new LayerGroup({
        title: 'Fond de plan',
        baseLayers:true,
        layers: [
            ignLayer,
            mntColorimetrieWmtsLayer,
            mntNbWmtsLayer,
            planIgnLayer
        ]
    });

    var baseLayers = new LayerGroup({
        title: 'All',
        baseLayers:true,
        layers: [
            ignLayer,
            mntColorimetrieWmtsLayer,
            mntNbWmtsLayer,
            planIgnLayer,

            geologieFiltreWmsLayer,
            carriereWmsLayer,

            foretWmsLayer,
            cultureWmsLayer,

            climatWmsLayer,

            communesWmsLayer,
            bvWmsLayer,
            brForetWmsLayer,
            brGeologieWmsLayer,
            brReliefWmsLayer,
            brTempWmsLayer,

            batimentVectorLayer
        ]
    });

    var matiereLayers  = new LayerGroup({
        title: 'Matiere',
        layers: [
            geologieFiltreWmsLayer,
            foretWmsLayer,
            cultureWmsLayer
        ]
    });

    var legendLayers = new LayerGroup({
        title: 'Legend',
        layers: [
            carriereWmsLayer,
            geologieFiltreWmsLayer,
            foretWmsLayer,
            cultureWmsLayer,
            brForetWmsLayer,
            brGeologieWmsLayer,
            brReliefWmsLayer,
            brTempWmsLayer,
            bvWmsLayer,
            climatWmsLayer
        ]
    });



    useEffect(() => {

        setLayers(baseLayers);
        setBackgroundLayers(backLayers);
        setLegendsLayers(legendLayers);
        setMatieresLayers(matiereLayers);

        const mapExtent = globalMapExtent;
        const mapObject = new Map({
            controls: [
                new Zoom(),
                new ScaleLine(),
                mousePositionTool,
            ],
            target: mapRef.current,
            layers: [baseLayers],
            view: new View({
                extent : mapExtent
            })
        });
        mapObject.getView().fit(startMapExtent);
        mapObject.addControl(printControlBar);
        mapObject.getView().on('change:resolution', (event) => {
            $('#reload').click();
        });


        const selectStyle = {};
        const select = new Select({
            style: function (feature) {
                //console.log(feature);
                //console.log(feature.get('style'));
                const image = feature.get('style').getImage().getImage();
                if (!selectStyle[image.src]) {
                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    context.drawImage(image, 0, 0, image.width, image.height);
                    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                    const data = imageData.data;
                    for (let i = 0, ii = data.length; i < ii; i = i + (i % 4 == 2 ? 2 : 1)) {
                        data[i] = 255 - data[i];
                    }
                    context.putImageData(imageData, 0, 0);
                    selectStyle[image.src] = createStyle(undefined, canvas);
                }
                return selectStyle[image.src];
            },
        });
        mapObject.addInteraction(select);

        mapObject.on('singleclick', function (evt) {
            $('#coordinatesClick').val(evt.coordinate);


            const feature = mapObject.forEachFeatureAtPixel(evt.pixel, function (feature) {
                return feature;
            });
            if (feature && feature.get('type')=='batiment') {

                let urlPhoto=urlDirectus+'assets/'+feature.get('photo');
                var batiment = {
                    "nom" : feature.get('nom'),
                    "photo" : urlPhoto,
                    "ref" : feature.get('ref'),
                    "adresse" : feature.get('adresse'),
                    "ville" : feature.get('ville'),
                    "infos" : feature.get('infos'),
                };
                setBatimentCourant(batiment);

                showPopupBatiment();
            }else{
                $('#btInfoMat').click();
            }
        });

        mapObject.on("pointermove", function (evt) {
            const feature = mapObject.forEachFeatureAtPixel(evt.pixel, function (feature) {
                return feature;
            });
            if (feature && feature.get('type')=='batiment') {
                this.getTargetElement().style.cursor = 'pointer';
            } else {
                this.getTargetElement().style.cursor = '';
            }
        });

        setMap(mapObject);

        return () => mapObject.setTarget(null)
    }, [])





    return (
        <MapContext.Provider value={{ map }}>
            <div className="container-fluid d-flex flex-column h-100 p-4">
                <SideBarEnd
                    closeDetailBatiment={closeDetailBatiment}
                    showPlanDeCoupe={showPlanDeCoupe}
                    batimentCourant={batimentCourant}
                    setAndShowImage={setAndShowImage}
                />
                <SideBarEndMatiere
                    closeDetailMatiere={closeDetailMatiere}
                    matiereCourante={matiereCourante}
                    setAndShowImage={setAndShowImage}
                />
                <div className="sidebar col-2 position-fixed start-0 top-0 z-2 py-4 ps-4 h-100">
                    <SideBar
                        showLayer={showLayer}
                        showLegend={showLegend}
                        getInfoMat={getInfoMat}

                        geologieLayerVisible={geologieLayerVisible}
                        showLayerGeologie={showLayerGeologie}
                        geologieRepresentation={geologieRepresentation}
                        setStyleGeologieLayer={setStyleGeologieLayer}

                        carrieresLayerVisible={carrieresLayerVisible}
                        showLayerCarrieres={showLayerCarrieres}
                        setStyleCarrieresLayer={setStyleCarrieresLayer}
                        carriereRepresentation={carriereRepresentation}

                        foretLayerVisible={foretLayerVisible}
                        showLayerForet={showLayerForet}
                        setStyleForetLayer={setStyleForetLayer}
                        foretRepresentation={foretRepresentation}

                        cultureLayerVisible={cultureLayerVisible}
                        showLayerCulture={showLayerCulture}
                        setStyleCultureLayer={setStyleCultureLayer}
                        cultureRepresentation={cultureRepresentation}

                        climatLayerVisible={climatLayerVisible}
                        showLayerClimat={showLayerClimat}
                        setStyleClimatLayer={setStyleClimatLayer}
                        climatRepresentation={climatRepresentation}
                        climatAnnee={climatAnnee}

                        setGeologieFilterAndRefresh={setGeologieFilterAndRefresh}
                        hideOtherDataLayer={hideOtherDataLayer}

                        bvWmsLayerVisible={bvWmsLayerVisible}
                        communesWmsLayerVisible={communesWmsLayerVisible}
                        brForetWmsLayerVisible={brForetWmsLayerVisible}
                        brGeologieWmsLayerVisible={brGeologieWmsLayerVisible}
                        brReliefWmsLayerVisible={brReliefWmsLayerVisible}
                        brTempWmsLayerVisible={brTempWmsLayerVisible}

                        showLayerBatiment={showLayerBatiment}
                        batimentLayerVisible={batimentLayerVisible}

                        selectGeoValue={selectGeoValue} setSelectGeoValue={setSelectGeoValue}
                        selectCarriereValue={selectCarriereValue} setSelectCarriereValue={setSelectCarriereValue}
                        selectForetValue={selectForetValue} setSelectForetValue={setSelectForetValue}
                        selectCultureValue={selectCultureValue} setSelectCultureValue={setSelectCultureValue}
                        selectClimatAnneeValue={selectClimatAnneeValue} setSelectClimatAnneeValue={setSelectClimatAnneeValue}
                        selectClimatValue={selectClimatValue} setSelectClimatValue={setSelectClimatValue}

                    />
                </div>
                <div className="row mx-0 position-relative">
                    <div className="col-12 col-header d-flex align-items-stretch justify-content-start pb-4 pe-0">
                        <Search selectCommune={selectCommune} setListHide={setListHide} listHide={listHide} />
                        <div className="d-flex align-items-center ps-5 ms-5 ms-lg-0">
                            Assemblothèque
                            <span className="ms-2 badge bg-primary rounded-pill">Bientôt</span>
                        </div>
                        <a onClick={showPopupEdito} className="btn btn-light btn-big ms-auto">A propos</a>
                    </div>
                </div>
                <div className="row mx-0 flex-grow-1 position-relative">
                    <div className="col-12 px-0 col-carte d-flex align-items-center justify-content-center position-relative overflow-hidden rounded-4">
                        <SelectBackground showBaseLayer={showBaseLayer} backgroundActif={backgroundActif} />
                        <div id="map"
                            style={{ height: "100%", width: "100%" }}
                            ref={mapRef}
                            className="map-container"
                        />
                        <div id="mouse-position" className="ol-coords-gps"> </div>
                        <div id="legend" className="ol-popupInfo">

                        </div>
                        <PlanDeCoupe affichePlanDeCoupeMaquette={affichePlanDeCoupeMaquette} setAndShowImage={setAndShowImage} resetAndShowOneLayer={resetAndShowOneLayer} batimentCourant={batimentCourant} closePlanDeCoupe={closePlanDeCoupe} setMatiereCouranteandShow={setMatiereCouranteandShow} />
                        <PopupMatiere listeMatiereCourante={listeMatiereCourante} setMatiereCouranteandShow={setMatiereCouranteandShow} closePopupMatiere={closePopupMatiere} />
                        <PopupBatiment batimentCourant={batimentCourant}  closePopupBatiment={closePopupBatiment} showDetailBatiment={showDetailBatiment} />
                        <PopupEdito closePopupEdito={closePopupEdito} />
                        <PopupImage closePopupImage={closePopupImage} imageCourante={imageCourante} imageScroll={imageScroll} />
                    </div>
                </div>
            </div>
        </MapContext.Provider>
    )
}

export default MapComponent;